






























import Vue from "vue";
declare const QRCode: any;

export default Vue.extend({
  props: {
    open: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      qrCode: null,
      menuLink: "",
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
  computed: {
    menuId(): string {
      return this.$store.getters["userModule/menuId"];
    },
  },
  // mounted() {},
  watch: {
    open() {
      if (this.open) {
        this.$nextTick(() => {
          this.menuLink = `${location.origin}/customer/${this.menuId}/generic`;
          console.log(this.menuLink);

          this.qrCode = new QRCode("qr-code", {
            text: this.menuLink,
            width: 265,
            height: 265,
            colorDark: "#75838b",
            colorLight: "#ffffff",
            correctLevel: QRCode.CorrectLevel.H,
          });
        });
      }
    },
  },
});
